// src/shims/WebView.web.js
import React from 'react';

export const WebView = ({ source = {}, style, ...rest }) => {
  const uri = source?.uri || '';
  // Twitch requires 'parent' query param
  const host = typeof window !== 'undefined' ? window.location.hostname : 'localhost';

  let src = uri;
  try {
    const u = new URL(uri);
    if (u.hostname.includes('twitch.tv')) {
      // Convert twitch.tv/* to player embed with parent
      const parts = u.pathname.split('/').filter(Boolean);
      if (parts[0] === 'videos' && parts[1]) {
        src = `https://player.twitch.tv/?video=${encodeURIComponent(parts[1])}&parent=${host}`;
      } else if (parts[0]) {
        src = `https://player.twitch.tv/?channel=${encodeURIComponent(parts[0])}&parent=${host}`;
      }
    }
  } catch (_) {}

  return (
    <iframe
      src={src}
      style={{ width: '100%', height: '100%', border: 0, borderRadius: 8, ...style }}
      allow="autoplay; fullscreen; picture-in-picture"
      allowFullScreen
      sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
      title="webview"
    />
  );
};

export default WebView;
